import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCoFlag = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 50,
	height: 50,
	viewBox: "0 0 50 50",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_1339_53082)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M49.9994 33.1899H-0.000488281V40.5175C-0.000488281 40.9935 0.385546 41.3796 0.861619 41.3796H49.1374C49.6135 41.3796 49.9995 40.9935 49.9995 40.5175L49.9994 33.1899Z",
					fill: "#CD343C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M49.9994 25H-0.000488281V9.48271C-0.000488281 9.00664 0.385546 8.62061 0.861619 8.62061H49.1374C49.6135 8.62061 49.9995 9.00664 49.9995 9.48271L49.9994 25Z",
					fill: "#FFE15A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M49.9994 25H-0.000488281V33.1894H49.9994V25Z",
					fill: "#41479B"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_1339_53082",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 50,
				height: 50,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgCoFlag);
export { ForwardRef as ReactComponent };
